<template>
  <div>
    <h4>Identificação</h4>
    <b-row class="border rounded-lg px-0 mx-0 py-3 mb-4">
      <b-col cols="9">
        <base-input label="Nome:" :show-warning="revisao('nome_programa')">
          <b-form-input
            v-model="oportunidade.nome"
            placeholder="Nome"
            :state="validateState('nome')"
          />
        </base-input>
      </b-col>

      <b-col cols="3">
        <base-input
          label="Código:"
          :show-warning="revisao('codigo')"
          invalid-feedback="Código é um campo obrigatório."
        >
          <b-form-input
            v-model="oportunidade.codigo"
            placeholder="Código"
            :state="validateState('codigo')"
          />
        </base-input>
      </b-col>

      <b-col cols="12">
        <b-form-group label="Logotipo/Imagem">
          <Arquivo v-model="oportunidade.imagem" />
        </b-form-group>
      </b-col>
    </b-row>

    <h4>Objeto e Descrição</h4>
    <b-row class="no-gutters border rounded-lg p-3 pb-1 mb-4">
      <b-col cols="12">
        <base-input
          label="Objeto:"
          class="custom-editor"
          :show-warning="revisao('categorias_do_programa')"
        >
          <Editor v-model="oportunidade.objeto" />
        </base-input>
      </b-col>
      <b-col cols="12">
        <base-input
          label="Descrição:"
          class="custom-editor mb-2"
          :show-warning="revisao('descricao')"
        >
          <Editor v-model="oportunidade.descricao" />
        </base-input>
      </b-col>
    </b-row>

    <h4>Instrumento, Categorias e Qualificação</h4>
    <div class="border rounded-lg p-3 mb-3">
      <base-input
        label="Tipo de Instrumento:"
        :show-warning="revisao('tipo_instrumento')"
      >
        <SelectTipoInstrumento v-model="oportunidade.tipo_instrumento_id" />
      </base-input>
      <hr />
      <b-form-group label="Categoria:">
        <SelectCategorias
          v-model="oportunidade.categorias"
          class="select-category"
        />
      </b-form-group>
      <hr />
      <b-form-group label="Qualificação da Proposta:">
        <b-form-checkbox
          name="qualificacao_proposta_checkbox"
          v-model="oportunidade.qualificacao_propostas"
          v-for="(proposta, key) in qualificacao_proposta"
          :key="key"
          :value="proposta.value"
          stacked
        >
          {{ proposta.text }}

          <div
            v-if="proposta.children && propostaSelecionada(proposta.value)"
            class="my-4"
          >
            <h4>{{ proposta.children_text }}</h4>
            <b-form-radio-group
              name="qualificacao_proposta_radio"
              v-model="oportunidade.qualificacao_propostas_emenda"
              :options="proposta.children"
              stacked
            />
          </div>
        </b-form-checkbox>
      </b-form-group>
    </div>
  </div>
</template>

<script>
import Editor from "@/components/Form/Editor.vue";
import SelectCategorias from "@/modules/categorias/Components/SelectCategorias.vue";
import SelectTipoInstrumento from "@/modules/oportunidades/Components/SelectTipoInstrumento.vue";
import Arquivo from "@/modules/files/Components/Arquivo.vue";
import BaseInput from "./BaseInput.vue";
import { defineComponent, watchEffect } from "vue";
import { useGetters, useNamespacedState } from "vuex-composition-helpers";
import { minLength, required } from "@vuelidate/validators";
import useVuelidate from "@vuelidate/core";
import { safeArray } from "@/helpers/functions/ArrayHelpers.js";

export default defineComponent({
  components: {
    Editor,
    Arquivo,
    BaseInput,
    SelectCategorias,
    SelectTipoInstrumento,
  },
  setup() {
    const { oportunidade } = useNamespacedState("oportunidades", [
      "oportunidade",
    ]);
    const oportunidades = useGetters("oportunidades", [
      "qualificacao_proposta",
    ]);

    const rules = {
      nome: {
        required,
        minLength: minLength(3),
      },
      codigo: {},
    };

    const v$ = useVuelidate(rules, oportunidade);

    function validateState(name) {
      const { $dirty, $error } = v$.value?.[name];
      return $dirty ? !$error : null;
    }

    function isValid() {
      v$.value.$touch();
      return !v$.value.$anyError;
    }

    function propostaSelecionada(value) {
      return oportunidade.value.qualificacao_propostas?.indexOf(value) >= 0;
    }

    function revisao(campo) {
      const existsRevisionField = !!oportunidade.value.campos_revisao;
      const existsOportunityData = !!oportunidade.value;

      if (existsOportunityData && existsRevisionField) {
        const checkReviewField = (item) => item.campo === campo;

        return safeArray(oportunidade.value.campos_revisao).some(
          checkReviewField
        );
      }

      return false;
    }

    watchEffect(() => {
      const source = oportunidade.value;
      const existsImage = !!source?.imagem;
      oportunidade.value.imagem_id = existsImage ? source?.imagem?.id : null;
    });

    return {
      oportunidade,
      ...oportunidades,
      isValid,
      propostaSelecionada,
      revisao,
      validateState,
    };
  },
});
</script>

<style scoped lang="scss">
::v-deep .select-category {
  max-width: 100%;
  width: 100%;
  display: inline-block;
  column-count: 2;
  column-gap: 32px;
  row-gap: 32px;
}

::v-deep .custom-editor {
  .ck-editor {
    width: 100%;
  }
}

.custom-last {
  margin-bottom: 0;
}
</style>
